var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3275 6.795H38.3625L34.4025 0.5175C34.2 0.2025 33.84 0 33.4575 0H20.565C20.1825 0 19.8225 0.2025 19.62 0.5175L15.66 6.795H7.69496C4.72496 6.795 2.29496 9.18 2.27246 12.1725V35.1225C2.27246 38.0925 4.70246 40.5 7.69496 40.5H46.35C49.32 40.5 51.75 38.115 51.7725 35.1225V12.1725C51.7725 9.2025 49.32 6.795 46.35 6.795H46.3275ZM49.4775 35.1225C49.4775 36.855 48.0375 38.25 46.305 38.25H7.67246C5.93996 38.25 4.52246 36.855 4.49996 35.1225V12.1725C4.49996 10.44 5.93996 9.045 7.67246 9.045H16.2675C16.65 9.045 17.01 8.8425 17.2125 8.5275L21.1725 2.25H32.8275L36.7875 8.505C36.99 8.8425 37.35 9.0225 37.7325 9.045H46.3275C48.06 9.045 49.4775 10.44 49.5 12.1725V35.1225H49.4775Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.955 11.4299C20.7675 11.4299 15.75 16.4474 15.75 22.6349C15.75 28.8224 20.7675 33.8399 26.955 33.8399C33.1425 33.8399 38.16 28.8224 38.16 22.6349C38.16 16.4474 33.1425 11.4299 26.955 11.4299ZM26.955 31.5899C22.005 31.5899 18 27.5849 18 22.6349C18 17.6849 22.005 13.6799 26.955 13.6799C31.905 13.6799 35.91 17.6849 35.91 22.6349C35.91 27.5849 31.905 31.5899 26.955 31.5899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ca6d5a447abcf53409d21d0061e2d4bb.svg";
export { ForwardRef as ReactComponent };